import React from 'react';
import { Modal } from 'antd';
import './modalConfirm.css'

const ModalConfirm = ({ visible, onOk, onCancel, title, content }) => {
  return (
    <Modal className='confirmModel'
      title={title}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <p>{content}</p>
    </Modal>
  );
};

export default ModalConfirm;